import { ZoomAdminManagedRollout } from '@features/zoom-admin-managed/rollout';
import { PrivateRoutes } from '@routes/enums';
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/admin/_zoomRollout')({
  component: () =>
    ZoomAdminManagedRollout.isEnabled() ? <Outlet /> : <Navigate to={PrivateRoutes.ADMIN_SETTINGS} replace />,
});
